import CatalogServices from "./CatalogServices.container";

export default CatalogServices;
